import { useQuery } from '@tanstack/react-query'
import { Armchair } from 'lucide-react'
import { convictionApi } from '../api/client'
import './BenchPanel.css'

interface BenchPanelProps {
  accountId: number
}

const BENCH_CAP = 25
const LIVE_CAP = 25

export function BenchPanel({ accountId }: BenchPanelProps) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['conviction-status', accountId],
    queryFn: () => convictionApi.status(accountId),
    retry: 1,
    refetchInterval: 30000,
  })

  const benched = data?.candidates_by_state?.benched ?? 0
  const pct = Math.min(100, Math.round((benched / BENCH_CAP) * 100))
  const hasData = data !== undefined

  return (
    <div className="card bench-panel">
      <div className="card-header">
        <h3 className="card-title">
          <Armchair size={18} className="icon" aria-hidden="true" />
          Bench
        </h3>
      </div>

      {isLoading ? (
        <div className="loading"><div className="spinner" /></div>
      ) : isError || !hasData ? (
        <div className="empty-state">
          <div className="empty-icon"><Armchair size={28} aria-hidden="true" /></div>
          <div className="empty-text">bench data unavailable</div>
        </div>
      ) : (
        <>
          <div className="bench-panel-track">
            <div className="bench-panel-fill" style={{ width: `${pct}%` }} />
          </div>
          <div className="bench-panel-value">
            <span className="num">{benched}</span> / {BENCH_CAP} bench slots
          </div>
          <p className="caption bench-panel-note">
            bench = vetted-but-not-entered; promoted when a live slot opens
          </p>
          {benched === 0 && (
            <p className="caption bench-panel-empty-hint">
              empty until picks graduate past the {LIVE_CAP} live slots — the strongest
              ~{LIVE_CAP} enter, the rest wait here
            </p>
          )}
        </>
      )}
    </div>
  )
}
